var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFoulCommitted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 24.13,
    cy: 37.01,
    r: 3.05,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.78,32.56a10.44,10.44,0,0,1,.53,7.6A10.64,10.64,0,1,1,20.57,27L41.69,16.67h0l4.37,7.23Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.71,16.66,33,13.89l-5.62,2.63-10.65,5c-2.12,1-4.25,2-6.37,3a11.52,11.52,0,0,0-4.93,4.6A11.08,11.08,0,0,0,4,35.49a11.87,11.87,0,0,0,3.33,7.13c2.84,3,6.53,4,10.45,4.71a26.67,26.67,0,0,0,6.39.31",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.83,
    y1: 23.91,
    x2: 20.05,
    y2: 19.95,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,20.41,26.3,17",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49,20a.53.53,0,0,1-.38-.16A.54.54,0,0,1,9,19.38V17a.56.56,0,0,1,.16-.41.52.52,0,0,1,.38-.15h3.45a.58.58,0,0,1,.41.15.56.56,0,0,1,.16.41v2.43a.54.54,0,0,1-.16.41.58.58,0,0,1-.41.16Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63,13.47a.54.54,0,0,1-.41-.16.53.53,0,0,1-.16-.41v-10a.53.53,0,0,1,.16-.41.54.54,0,0,1,.41-.16h3.2a.56.56,0,0,1,.41.16.57.57,0,0,1,.16.41v10a.57.57,0,0,1-.16.41.56.56,0,0,1-.41.16Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoulCommitted);
export default __webpack_public_path__ + "static/media/FOUL_COMMITTED.ca6d247b39f20b166c0e990782a5f0ae.svg";
export { ForwardRef as ReactComponent };